import { constantsData } from "@/data";
import { NetworkModeEnum } from "@/enums";
import { generateValidClassNameHandler } from "@/lib/utils";
import { NetworkModeType } from "@/types";

export const NetworkModeBar = ({ mode } : { mode: NetworkModeType }) => {
    if (mode === NetworkModeEnum.CONNECTED) return null;

    return (
        <div
            aria-live="polite"
            role="status"
            className={generateValidClassNameHandler(
                "fixed inset-x-0 bottom-0 z-50 px-2 md:px-4 py-2 shadow-lg text-background dark:text-foreground text-sm md:text-base",
                mode === NetworkModeEnum.ONLINE ? "bg-success" : "bg-danger",
            )}
        >
            {mode === NetworkModeEnum.ONLINE ? constantsData.titles.onlineNetwork : constantsData.titles.offlineNetwork}
        </div>
    );
};
